require('./bootstrap');
import Editor from '@toast-ui/editor'
import '@toast-ui/editor/dist/toastui-editor.css';
import Alpine from 'alpinejs';
// import intersect from '@alpinejs/intersect';
import mask from '@alpinejs/mask';

// Alpine.plugin(intersect)
Alpine.plugin(mask);
window.Alpine = Alpine;
Alpine.start();
window.Editor = Editor;

// const editor = new Editor({
//     el: document.querySelector('#editor'),
//     height: '400px',
//     initialEditType: 'wysiwyg',
//     placeholder: 'Enter Privacy Notice',
// })
//
// editor.on('blur', function (e) {
//     console.log(editor.getMarkdown());
// });
